import { ComparaisonOperator } from '../../Enums/comparaison-operator';

/**
 * Remarks : Les propriétés de cette classe sont en PascalCase car coté API il s'agit d'un dynamic qui lorsqu'il est sérialisé
 * n'applique pas la transformation des noms de propriété en CamelCase.
 */
export class HttpCodeConditionDatas {
    public HttpCode: string;
    public Operator: ComparaisonOperator;
}
